import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withKeys as _withKeys, createVNode as _createVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/img/icon/route-black-new.svg'


const _hoisted_1 = {
  class: "flex w-full items-center justify-between",
  style: {"padding":"0px 5px 8px 5px"}
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "text-2xl font-bold" }, "Detail Pendapatan Tiket"),
  /*#__PURE__*/_createElementVNode("div", null, "Berikut adalah detail pendapatan tiket per-RIT ")
], -1)
const _hoisted_3 = { class: "content" }
const _hoisted_4 = { class: "border-grey-3" }
const _hoisted_5 = { class: "flex items-center justify-between px-6 pt-6 mb-4" }
const _hoisted_6 = { class: "text-xl font-bold text-primary" }
const _hoisted_7 = { class: "flex items-center gap-3" }
const _hoisted_8 = { class: "text-grey text-base font-normal" }
const _hoisted_9 = { class: "flex items-center gap-3" }
const _hoisted_10 = { class: "w-fit cursor-pointer" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "flex items-center gap-5" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "flex items-center gap-2" }, [
    /*#__PURE__*/_createElementVNode("div", null, [
      /*#__PURE__*/_createElementVNode("i", { class: "pi pi-filter-fill text-grey-4" })
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "text-grey-4 text-base" }, "Filter")
  ]),
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("i", { class: "text-grey-4 pi pi-angle-down" })
  ])
], -1)
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = { class: "px-6 pt-6 mb-4" }
const _hoisted_14 = { class: "md:grid md:grid-cols-2 lg:grid-cols-4 gap-3" }
const _hoisted_15 = { class: "rounded-lg border-grey-3 p-3" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-col lg:flex-row items-start mb-3" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "mr-0 lg:mr-2 font-extrabold text-base" }, "Penumpang"),
  /*#__PURE__*/_createElementVNode("div", null, "(total penumpang)")
], -1)
const _hoisted_17 = { class: "text-3xl font-extrabold" }
const _hoisted_18 = { class: "rounded-lg border-grey-3 p-3" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-col lg:flex-row items-start mb-3" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "mr-0 lg:mr-2 font-extrabold text-base" }, "Online"),
  /*#__PURE__*/_createElementVNode("div", null, "(total penumpang online yang check in)")
], -1)
const _hoisted_20 = { class: "text-3xl font-extrabold" }
const _hoisted_21 = { class: "rounded-lg border-grey-3 p-3" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-col lg:flex-row items-start mb-3" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "mr-0 lg:mr-2 font-extrabold text-base" }, "Tiket Hangus"),
  /*#__PURE__*/_createElementVNode("div", null, "(total penumpang tidak check in)")
], -1)
const _hoisted_23 = { class: "text-3xl font-extrabold" }
const _hoisted_24 = { class: "rounded-lg border-grey-3 p-3" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-col lg:flex-row items-start mb-3" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "mr-0 lg:mr-2 font-extrabold text-base" }, "Pendapatan"),
  /*#__PURE__*/_createElementVNode("div", null, "(total pendapatan tiket)")
], -1)
const _hoisted_26 = { class: "text-3xl font-extrabold" }
const _hoisted_27 = { class: "background-grey-1 px-6 py-3" }
const _hoisted_28 = { class: "flex items-center justify-between" }
const _hoisted_29 = { class: "flex items-center gap-2" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_31 = { class: "text-base font-bold" }
const _hoisted_32 = { class: "text-base font-bold" }
const _hoisted_33 = { class: "py-4 px-6" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("div", { class: "text-grey-4 text-sm italic" }, "Oops, data yang Anda cari tidak ditemukan", -1)
const _hoisted_35 = { class: "ml-2" }
const _hoisted_36 = ["onClick"]
const _hoisted_37 = { class: "flex items-center pt-5" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("p", { class: "font-bold text-sm text-primary" }, /*#__PURE__*/_toDisplayString("Kembali"), -1)
const _hoisted_39 = /*#__PURE__*/_createElementVNode("div", { class: "pb-2 border-bottom-grey-5" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "text-base text-grey-5 font-bold" }, "FIlter Asal - Tujuan")
], -1)
const _hoisted_40 = { class: "py-2" }
const _hoisted_41 = { class: "flex items-center gap-2" }
const _hoisted_42 = { class: "flex items-center justify-end gap-3" }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("p", { class: "font-bold text-sm text-primary" }, /*#__PURE__*/_toDisplayString("Reset"), -1)
const _hoisted_44 = /*#__PURE__*/_createElementVNode("p", { class: "font-bold text-sm text-white" }, /*#__PURE__*/_toDisplayString("Apply"), -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputIconRight = _resolveComponent("InputIconRight")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_Paginator = _resolveComponent("Paginator")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_OverlayPanel = _resolveComponent("OverlayPanel")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_Dialog, {
      class: "approve-modal",
      showHeader: true,
      visible: $setup.showModal,
      "onUpdate:visible": _cache[4] || (_cache[4] = ($event: any) => (($setup.showModal) = $event)),
      breakpoints: { '960px': '75vw', '640px': '90vw' },
      style: { width: '95vw' },
      modal: true,
      contentClass: "wrap-ctn-modal-default"
    }, {
      header: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _hoisted_2,
          _createElementVNode("div", null, [
            _createElementVNode("i", {
              class: "pi pi-times cursor-pointer",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.closeDialog && $setup.closeDialog(...args)))
            })
          ])
        ])
      ]),
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_37, [
          _createVNode(_component_Button, {
            class: "extra-submit-button",
            onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.closeDialog()))
          }, {
            default: _withCtx(() => [
              _hoisted_38
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_6, _toDisplayString($props.dataDetail.regNumber), 1),
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, _toDisplayString(`${$props.dataDetail.originCity} - ${$props.dataDetail.destinationCity}`), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", null, [
                  _createVNode(_component_InputIconRight, {
                    class: "input-search-header-custom",
                    placeholder: $setup.placeholder,
                    modelValue: $setup.inputSearch,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.inputSearch) = $event)),
                    canClick: true,
                    icon: $setup.icon.svg.searchEva,
                    onSubmitInput: $setup.onSearch,
                    onKeyup: _withKeys($setup.onSearch, ["enter"])
                  }, null, 8, ["placeholder", "modelValue", "icon", "onSubmitInput", "onKeyup"])
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", {
                    class: "btn-back px-4 py-2 rounded",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.onClickFilterOptions($event)))
                  }, _hoisted_12)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, [
                  _hoisted_16,
                  _createElementVNode("div", _hoisted_17, _toDisplayString($props.dataDetail.totalPassenger), 1)
                ]),
                _createElementVNode("div", _hoisted_18, [
                  _hoisted_19,
                  _createElementVNode("div", _hoisted_20, _toDisplayString(`${$props.dataDetail.totalPassengerCheckIn} / ${$props.dataDetail.totalTicketBooking}`), 1)
                ]),
                _createElementVNode("div", _hoisted_21, [
                  _hoisted_22,
                  _createElementVNode("div", _hoisted_23, _toDisplayString($props.dataDetail.totalExpiredTicket), 1)
                ]),
                _createElementVNode("div", _hoisted_24, [
                  _hoisted_25,
                  _createElementVNode("div", _hoisted_26, _toDisplayString($setup.currencyNumberFormat($props.dataDetail.totalIncome)), 1)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_27, [
              _createElementVNode("div", _hoisted_28, [
                _createElementVNode("div", _hoisted_29, [
                  _hoisted_30,
                  _createElementVNode("div", _hoisted_31, _toDisplayString($props.dataDetail.routeName), 1)
                ]),
                _createElementVNode("div", _hoisted_32, _toDisplayString($props.dataDetail.ritDate), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_33, [
              _createVNode(_component_DataTable, {
                value: $setup.dataSource,
                tableStyle: "width: 100%",
                class: "income-detail-table"
              }, {
                empty: _withCtx(() => [
                  _hoisted_34
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_Column, { header: "WAKTU BOOKING" }, {
                    body: _withCtx((slotProps) => [
                      _createElementVNode("p", null, _toDisplayString(slotProps.data.BookingDraft ? $setup.moment(slotProps.data.BookingDraft.CreatedAt.toString()).format('DD MMM YYYY HH:mm:ss') : '-'), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_Column, { header: "WAKTU CHECK IN" }, {
                    body: _withCtx((slotProps) => [
                      _createElementVNode("p", null, _toDisplayString(slotProps.data.BookingDraft ? $setup.moment(slotProps.data.BookingDraft.CheckinAt.toString()).format('DD MMM YYYY HH:mm:ss') : '-'), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_Column, { header: "STATUS BOOKING" }, {
                    body: _withCtx((slotProps) => [
                      _createElementVNode("p", {
                        class: _normalizeClass(slotProps.data.bookingStatus.class)
                      }, _toDisplayString(slotProps.data.bookingStatus.label), 3)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_Column, {
                    field: "rit",
                    header: "ASAL-TUJUAN"
                  }),
                  _createVNode(_component_Column, {
                    field: "MsPassengerName",
                    header: "JENIS"
                  }),
                  _createVNode(_component_Column, { header: "NOMOR WA" }, {
                    body: _withCtx((slotProps) => [
                      _createElementVNode("p", null, _toDisplayString(slotProps.data.WhatsAppNumber ?? '-'), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_Column, { header: "HARGA" }, {
                    body: _withCtx((slotprops) => [
                      _createElementVNode("p", null, _toDisplayString($setup.currencyNumberFormat(slotprops.data.Price)), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_Column, {
                    field: "MsStatusName",
                    header: "JENIS TIKET"
                  }),
                  _createVNode(_component_Column, { header: "WAKTU BUAT TIKET" }, {
                    body: _withCtx((slotProps) => [
                      _createElementVNode("p", null, _toDisplayString($setup.moment(slotProps.data.CreatedAt.toString()).format('DD MMM YYYY HH:mm:ss')), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_Column, { header: "KODE TIKET" }, {
                    body: _withCtx((slotProps) => [
                      _createElementVNode("p", null, [
                        _createTextVNode(_toDisplayString(slotProps.data.Code) + " ", 1),
                        _createElementVNode("span", _hoisted_35, [
                          _createElementVNode("i", {
                            class: "pi pi-copy text-primary text-xs font-normal cursor-pointer text-base",
                            title: "Salin",
                            onClick: ($event: any) => ($setup.onCopy(slotProps.data.Code))
                          }, null, 8, _hoisted_36)
                        ])
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["value"]),
              _createVNode(_component_Paginator, {
                class: "trayek-pagination",
                rows: $setup.filters.pageSize,
                totalRecords: $setup.totalTrayekRecords,
                onOnPage: $setup.onChangePage
              }, null, 8, ["rows", "totalRecords", "onOnPage"])
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_OverlayPanel, { ref: "refOverlayAction" }, {
      default: _withCtx(() => [
        _hoisted_39,
        _createElementVNode("div", _hoisted_40, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.filterOptions, (data) => {
            return (_openBlock(), _createElementBlock("div", {
              key: data,
              class: "mb-2"
            }, [
              _createElementVNode("div", _hoisted_41, [
                _createVNode(_component_Checkbox, {
                  modelValue: $setup.selectedFilter,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($setup.selectedFilter) = $event)),
                  class: "checkbox-primary mr-3",
                  name: data.label,
                  value: data.value
                }, null, 8, ["modelValue", "name", "value"]),
                _createElementVNode("div", null, _toDisplayString(data.label), 1)
              ])
            ]))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_42, [
          _createVNode(_component_Button, {
            class: "extra-submit-button",
            onClick: _cache[6] || (_cache[6] = ($event: any) => ($setup.resetFilterOptions()))
          }, {
            default: _withCtx(() => [
              _hoisted_43
            ]),
            _: 1
          }),
          _createVNode(_component_Button, {
            class: "btn-primary",
            onClick: _cache[7] || (_cache[7] = ($event: any) => ($setup.applyFilter()))
          }, {
            default: _withCtx(() => [
              _hoisted_44
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }, 512)
  ]))
}